import React, { useContext } from "react"
import { View } from "react-native"
import FilledButtonM from "../../common/components/button/FilledButtonM"
import UncontrolledTextInputM from "../../common/components/input/UncontrolledTextInputM"
import { ListGroupM } from "../../common/components/list/ListGroupM"
import { ListItemM } from "../../common/components/list/ListItemM"
import { theme } from "../../common/theme/theme"
import { DimensionsContext } from "../../common/utils/mobileUtils"

const PrecisionAnswerComponent = (props) => {
    const {
        control,
        goToNextStep,
        setFormValues,
        field,
        data,
        setPrecisions,
        precisions,
        inputName,
        optionalPrecision,
        placeHolderText,
    } = props

    const dimensions = useContext(DimensionsContext)

    const selectedOption = data?.find((option) => option.value === field.value)

    const shouldShowTextInput = !!selectedOption

    const showNext =
        (!shouldShowTextInput ||
            precisions[field.name] ||
            (optionalPrecision && field.value?.length > 0)) &&
        field.value?.length > 0

    return (
        <View style={{ flex: 1, alignItems: "center" }}>
            <ListGroupM
                options={data}
                style={{
                    marginBottom: 20,
                }}
                itemHeight={70}
                renderItem={(item) => {
                    return (
                        <ListItemM
                            isFirst={item.index === 0}
                            isLast={item.index === data?.length - 1}
                            style={{ paddingVertical: 5 }}
                            onPress={() => {
                                field.onChange(item.item?.value)
                                setFormValues({
                                    ...control._formValues,
                                    [field?.name]: item.item?.value,
                                })
                            }}
                            itemHeight={80}
                            selected={item.item?.value === field.value}
                            option={item.item}
                        />
                    )
                }}
            />
            {shouldShowTextInput && (
                <UncontrolledTextInputM
                    placeholder={placeHolderText ?? inputName}
                    name="precisions"
                    style={{
                        height: 120,
                        backgroundColor: theme.colors.white,
                        width: dimensions.width - 40,
                        alignSelf: "center",
                    }}
                    multiline={true}
                    onChangeText={(value) => {
                        setPrecisions({
                            ...precisions,
                            [field.name]: value,
                        })
                    }}
                />
            )}
            {showNext && (
                <FilledButtonM
                    label={"Suivant"}
                    color={theme.colors.primary}
                    style={{
                        position: "absolute",
                        bottom: 20,
                        width: dimensions.width - 40,
                    }}
                    onPress={goToNextStep}
                />
            )}
        </View>
    )
}

export default PrecisionAnswerComponent
